// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"e05f5bbd","782":"cb956e7c"}[chunkId] + ".chunk.css";
};